import { render, staticRenderFns } from "./KoppelingMysolution.vue?vue&type=template&id=59baae94&"
import script from "./KoppelingMysolution.vue?vue&type=script&lang=ts&"
export * from "./KoppelingMysolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports